'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import Footer from '../footer/Footer';

var TwoColumnLayout = function TwoColumnLayout(_ref) {
  var leftContent = _ref.leftContent,
      rightContent = _ref.rightContent,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["leftContent", "rightContent", "className"]);

  return /*#__PURE__*/_jsxs("div", Object.assign({
    className: className + " two-column-layout"
  }, otherProps, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "left-column",
      children: leftContent
    }), /*#__PURE__*/_jsxs("div", {
      className: "right-column",
      children: [rightContent, /*#__PURE__*/_jsx(Footer, {})]
    })]
  }));
};

export default TwoColumnLayout;